export enum IGenerateFileActionTypes {
    GENERATE_FILE_XML = '@@GenerateFile/GENERATE_FILE_XML',
    GENERATE_FILE_XML_SUCCESS = '@@GenerateFile/GENERATE_FILE_XML_SUCCESS',
    GENERATE_FILE_XML_ERROR = '@@GenerateFile/GENERATE_FILE_XML_ERROR',
}

export interface IGenerateFileState {
    readonly xml_response: string;
}
